export default {"src":"/_next/static/media/meta.f6a05c55.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};